import type { LaneProjection, ProjectionStatus } from "./projection.types";

export type ProjectionHealthSummary = {
  total: number;
  byStatus: Record<ProjectionStatus, number>;
};

export function summarizeProjectionHealth(projections: LaneProjection[]): ProjectionHealthSummary {
  const byStatus: Record<ProjectionStatus, number> = {
    fresh: 0,
    stale: 0,
    invalid: 0,
    review_required: 0,
  };

  for (const projection of projections) {
    byStatus[projection.status] += 1;
  }

  return {
    total: projections.length,
    byStatus,
  };
}

export function markStaleProjections(projections: LaneProjection[], maxAgeMs: number, nowMs = Date.now()): LaneProjection[] {
  return projections.map((projection) => {
    if (!projection.generatedAtMs) return projection;
    if (nowMs - projection.generatedAtMs <= maxAgeMs) return projection;
    return {
      ...projection,
      status: projection.status === "invalid" ? projection.status : "stale",
    };
  });
}